// adding check box set validation

const rule = {
	name: 'validateCheckboxSet',
	method: (value, element, params) => $('.validateCheckboxSet:checked').length !== 0,
	errorMessage: (params, element) => 'This field is required'
};

export default rule;
